export const bundleInfo = {
	GB: {
		bundleId: 'BU698395958990ca091d77ed283c0bef61',
		addressId: 'AD1e139100e33ce4d4a35d8c2a8fe821a7',
		countryCode: 'GB',
	},
	AU: {
		bundleId: 'BUd83a873c527182a35ddf697060b120e5',
		addressId: 'AD1e67bc4bde07259245e918525e3bea8d',
		countryCode: 'AU',
	},
};
